import React from 'react'
import {
  Button,
  Toolbar,
  IconButton,
  Box,
  Typography,
  AppBar,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material'
import { AddCircleOutline, Close, InfoOutlined, KeyboardArrowDownRounded } from '@mui/icons-material'
import { Save } from 'lucide-react'

import { ReactComponent as SqureIcon } from '../../assets/icons/square.svg'
import { ReactComponent as SqureGridIcon } from '../../assets/icons/square-grid.svg'
import { ReactComponent as StarIcon } from '../../assets/icons/star.svg'

import { useBuilderStore } from '@/views/NewBuilder/hooks/builder/useBuilderStore'

function RubricAppBar({
  onClose = () => {},
  handleSave = () => {},
  handleSetAsDefault = () => {},
  handleCreateRubric = () => {},
  rubric,
  saving = false,
  tab,
  isActivitySettings,
  isOnlyOneSave = false,
}) {
  const isFormOpen = useBuilderStore(store => store.isFormOpen)
  const [anchorEl, setAnchorEl] = React.useState(null)

  const menuItems = [
    {
      id: 1,
      title: 'Apply to this card',
      icon: <SqureIcon />,
      onClick: () => handleSave(false),
      tip: 'Use this rubric for this card only.',
    },
    {
      id: 2,
      title: 'Apply to all cards in this activity',
      icon: <SqureGridIcon />,
      hide: isFormOpen,
      onClick: () => handleSave(true),

      tip: 'Use this rubric for all cards in this activity, including future respond cards. You may still override this rubric on individual cards.',
    },
    {
      id: 3,
      title: 'Set as my default rubric',
      icon: <StarIcon />,
      onClick: handleSetAsDefault,
      tip: 'Use this rubric as your default rubric when creating new activities.',
    },
  ]

  return (
    <AppBar
      position="sticky"
      sx={{
        bgcolor: 'white',
      }}
    >
      <Toolbar
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <IconButton onClick={onClose}>
            <Close
              sx={{
                height: '20px',
                width: '20px',
                color: '#475467',
              }}
            />
          </IconButton>
          <Typography color="#475467" fontSize={14} fontWeight={500}>
            Rubrics
          </Typography>
          <Typography color="success.main" fontSize={12}>
            {saving ? 'Saving...' : null}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          {rubric && !isOnlyOneSave ? (
            <>
              <Button
                endIcon={<KeyboardArrowDownRounded />}
                size="large"
                variant="outlined"
                onClick={e => setAnchorEl(e.currentTarget)}
              >
                Use this rubric
              </Button>

              <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'bottom',
                }}
                open={Boolean(anchorEl)}
                sx={{
                  '& .MuiMenu-paper': {
                    border: '1px solid #EAECF0',
                    borderRadius: '6px',
                    mt: 1,
                    // width: "280px",
                  },
                }}
                onClose={() => setAnchorEl(null)}
              >
                {menuItems
                  .filter(i => !i.hide && (!isActivitySettings || i.id != 1))
                  .map(item => (
                    <MenuItem key={item.id} onClick={item.onClick}>
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <ListItemText
                        primary={
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              alignItems: 'center',
                            }}
                          >
                            <Typography>{item.title}</Typography>
                            <Tooltip title={item.tip}>
                              <span>
                                <InfoOutlined
                                  sx={{
                                    fontSize: 14,
                                  }}
                                />
                              </span>
                            </Tooltip>
                          </Box>
                        }
                        sx={{
                          '& .MuiListItemText-primary': {
                            color: '#344054',
                            fontSize: 14,
                            fontWeight: 500,
                          },
                        }}
                      />
                    </MenuItem>
                  ))}
              </Menu>
            </>
          ) : null}

          {tab !== 'new' && (
            <Button
              size="large"
              startIcon={<AddCircleOutline />}
              variant={!isOnlyOneSave ? 'contained' : 'outlined'}
              onClick={handleCreateRubric}
            >
              Create New Rubric
            </Button>
          )}
          {isOnlyOneSave ? (
            <Button
              size="large"
              startIcon={<Save size={20} />}
              variant="contained"
              onClick={() => {
                handleSave(false)
              }}
            >
              Use this rubric
            </Button>
          ) : null}
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default RubricAppBar
